export default __webpack_public_path__ + "static/backgroundAwards-e8a9a7c6a2965c9ee281c44025da1498.jpg";